import React, { Component } from "react";
import axios from 'axios';
import moment from 'moment-timezone';
import { Link } from 'react-router-dom';
import { Configurations } from '../../Utils/Configurations';

// Valores fixos de "action" reconhecidos pelo app (RedirectService) para abrir um modal/tela
// específica ao tocar na notificação — mantidos em sincronia manual com o app mobile.
const ACOES_DISPONIVEIS = [
    { valor: 'atualizacao_cadastral', label: 'Modal de atualização cadastral' },
    { valor: 'daimoku', label: 'Diário de Daimoku' },
    { valor: 'incentivo_dia', label: 'Modal de incentivo do dia' },
];

// Tela de criação/disparo de campanhas de notificação push (FCM), para a equipe de Marketing.
class CampaignCreate extends Component {

    constructor(props) {
        super(props);

        this.handleChange = this.handleChange.bind(this);
        this.handleChangeSegmentacao = this.handleChangeSegmentacao.bind(this);
        this.handleChangePlataforma = this.handleChangePlataforma.bind(this);
        this.handleChangeTipoParametro = this.handleChangeTipoParametro.bind(this);
        this.handleToggleAgendamento = this.handleToggleAgendamento.bind(this);
        this.carregaEstimativaPublico = this.carregaEstimativaPublico.bind(this);
        this.enviar = this.enviar.bind(this);
        this.salvarRascunho = this.salvarRascunho.bind(this);
        this.agendar = this.agendar.bind(this);
        this.salvarEdicao = this.salvarEdicao.bind(this);
        this.enviarCampanhaSalva = this.enviarCampanhaSalva.bind(this);

        this.Configurations = new Configurations();

        const { campanhaParaCopiar, campanhaParaEditar } = (props.location && props.location.state) || {};

        if (campanhaParaEditar) {
            this.state = this.estadoParaEdicao(campanhaParaEditar);
        } else if (campanhaParaCopiar) {
            this.state = this.estadoAPartirDaCopia(campanhaParaCopiar);
        } else {
            this.state = this.estadoVazio();
        }
    }

    estadoVazio() {
        return {
            titulo: '',
            corpo: '',
            tipoSegmentacao: 'todos',
            plataforma: 'android',
            topico: '',
            tokensTexto: '',
            tipoParametro: 'nenhum',
            url: '',
            action: '',
            agendarCampanha: false,
            dtAgendamentoData: '',
            dtAgendamentoHora: '',
            dtAgendamentoMinuto: '00',
            isSending: false,
            resultado: null,
            idCampanhaOrigem: null,
            idCampanhaEditando: null,
            estimativaPublico: null,
            isLoadingEstimativa: false,
            formAlteradoDesdeSalvar: false,
        };
    }

    // Campos comuns a partir de uma campanha existente, usado tanto pra "copiar" (vira campanha
    // nova) quanto pra "editar" (atualiza a mesma, só permitido enquanto for rascunho/agendada). Tokens
    // só vêm preenchidos porque a tela de detalhes busca a campanha via buscaCampanha
    // (incluirTokens: true) antes de navegar pra cá. dtAgendamento vem em UTC — convertido pros três
    // seletores (data/hora/minuto) já em horário de Brasília.
    _camposAPartirDaCampanha(campanha) {
        const segmentacao = campanha.segmentacao || {};
        const parametros = campanha.parametros || {};
        const momentoAgendado = campanha.dtAgendamento
            ? moment.utc(campanha.dtAgendamento).tz('America/Sao_Paulo')
            : null;

        return {
            titulo: campanha.titulo || '',
            corpo: campanha.corpo || '',
            tipoSegmentacao: segmentacao.tipo || 'todos',
            plataforma: segmentacao.tipo === 'plataforma' ? segmentacao.valor : 'android',
            topico: segmentacao.tipo === 'topico' ? (segmentacao.valor || '') : '',
            tokensTexto: segmentacao.tipo === 'tokens' ? (segmentacao.tokens || []).join('\n') : '',
            tipoParametro: parametros.url ? 'url' : (parametros.action ? 'action' : 'nenhum'),
            url: parametros.url || '',
            action: parametros.action || '',
            agendarCampanha: !!campanha.dtAgendamento,
            dtAgendamentoData: momentoAgendado ? momentoAgendado.format('YYYY-MM-DD') : '',
            dtAgendamentoHora: momentoAgendado ? String(momentoAgendado.hour()) : '',
            dtAgendamentoMinuto: momentoAgendado ? (momentoAgendado.minute() < 30 ? '00' : '30') : '00',
            isSending: false,
            resultado: null,
            estimativaPublico: null,
            isLoadingEstimativa: false,
            formAlteradoDesdeSalvar: false,
        };
    }

    // Botão "Copiar para nova campanha" no histórico — campanhas antigas podem ter outras chaves
    // em "parametros" (de antes dessa tela fixar só url/action); essas são ignoradas na cópia.
    // Agendamento nunca é copiado — a cópia vira uma campanha nova, sem data herdada do original.
    estadoAPartirDaCopia(campanha) {
        return {
            ...this._camposAPartirDaCampanha(campanha),
            agendarCampanha: false,
            dtAgendamentoData: '',
            dtAgendamentoHora: '',
            dtAgendamentoMinuto: '00',
            idCampanhaOrigem: campanha.idCampanha || null,
            idCampanhaEditando: null,
        };
    }

    // Botão "Editar rascunho"/"Editar agendamento" no histórico — oferecido pra campanhas com
    // status "rascunho" ou "agendada".
    estadoParaEdicao(campanha) {
        return {
            ...this._camposAPartirDaCampanha(campanha),
            idCampanhaOrigem: null,
            idCampanhaEditando: campanha.idCampanha || null,
        };
    }

    componentDidMount() {
        this.carregaEstimativaPublico();
    }

    handleChange(e) {
        this.setState({ [e.target.name]: e.target.value, formAlteradoDesdeSalvar: true });
    }

    handleChangeSegmentacao(e) {
        this.setState({ tipoSegmentacao: e.target.value, formAlteradoDesdeSalvar: true }, this.carregaEstimativaPublico);
    }

    handleChangePlataforma(e) {
        this.setState({ plataforma: e.target.value, formAlteradoDesdeSalvar: true }, this.carregaEstimativaPublico);
    }

    handleChangeTipoParametro(e) {
        this.setState({ tipoParametro: e.target.value, formAlteradoDesdeSalvar: true });
    }

    handleToggleAgendamento(e) {
        this.setState({ agendarCampanha: e.target.checked, formAlteradoDesdeSalvar: true });
    }

    // Estimativa de alcance antes do disparo, pra "todos"/"plataforma" (pra "tokens" a contagem já
    // é visível pelo que foi colado no campo). É aproximada — sessões ativas mudam o tempo todo.
    carregaEstimativaPublico() {
        const { tipoSegmentacao, plataforma } = this.state;

        if (tipoSegmentacao !== 'todos' && tipoSegmentacao !== 'plataforma') {
            return this.setState({ estimativaPublico: null });
        }

        this.setState({ isLoadingEstimativa: true });
        const query = tipoSegmentacao === 'plataforma' ? `tipo=plataforma&plataforma=${plataforma}` : 'tipo=todos';

        axios.get(this.Configurations.apiBasePath + `/campanhas-push/estimativa-publico?${query}`)
            .then(response => {
                this.setState({ estimativaPublico: response.data.totalDispositivos });
            }).catch(() => {
                this.setState({ estimativaPublico: null });
            }).finally(() => this.setState({ isLoadingEstimativa: false }));
    }

    montaParametros() {
        switch (this.state.tipoParametro) {
            case 'url':
                return this.state.url.trim() !== '' ? { url: this.state.url.trim() } : {};
            case 'action':
                return this.state.action !== '' ? { action: this.state.action } : {};
            default:
                return {};
        }
    }

    // TODO: segmentação de público — adicionar opções de filtro por localidade, função, divisão,
    // assinantes/não-assinantes (parametrizado por produto) e última versão instalada, acompanhando
    // os novos tipos de segmentação do backend.
    montaSegmentacao() {
        const { tipoSegmentacao, plataforma, topico, tokensTexto } = this.state;

        switch (tipoSegmentacao) {
            case 'plataforma':
                return { tipo: 'plataforma', plataforma };
            case 'topico':
                return { tipo: 'topico', topico: topico.trim() };
            case 'tokens':
                return {
                    tipo: 'tokens',
                    tokens: tokensTexto.split(/[\n,]+/).map(t => t.trim()).filter(Boolean)
                };
            default:
                return { tipo: 'todos' };
        }
    }

    validaFormulario({ exigirAgendamento = false } = {}) {
        const { titulo, corpo, tipoSegmentacao, topico, tokensTexto, tipoParametro, url, action } = this.state;

        if (!titulo.trim() || !corpo.trim()) {
            return "Informe título e corpo da notificação.";
        }
        if (tipoSegmentacao === 'topico' && !topico.trim()) {
            return "Informe o nome do tópico.";
        }
        if (tipoSegmentacao === 'tokens' && tokensTexto.split(/[\n,]+/).map(t => t.trim()).filter(Boolean).length === 0) {
            return "Informe ao menos um token de dispositivo.";
        }
        if (tipoParametro === 'url' && !url.trim()) {
            return "Informe a URL.";
        }
        if (tipoParametro === 'action' && !action) {
            return "Selecione uma action.";
        }
        if (exigirAgendamento) {
            if (!this.dtAgendamentoLocalString()) {
                return "Informe a data, a hora e o minuto do agendamento.";
            }
            const momentoAgendado = this.dtAgendamentoMoment();
            if (!momentoAgendado.isValid() || momentoAgendado.valueOf() <= Date.now()) {
                return "A data de agendamento deve ser no futuro.";
            }
        }
        return null;
    }

    // Combina os três seletores (data + hora + minuto, 00/30) num horário "YYYY-MM-DDTHH:mm" —
    // minuto já vem restrito pelo <select>, então não precisa validar de novo aqui.
    dtAgendamentoLocalString() {
        const { dtAgendamentoData, dtAgendamentoHora, dtAgendamentoMinuto } = this.state;
        if (!dtAgendamentoData || dtAgendamentoHora === '' || !dtAgendamentoMinuto) return null;
        return `${dtAgendamentoData}T${String(dtAgendamentoHora).padStart(2, '0')}:${dtAgendamentoMinuto}`;
    }

    dtAgendamentoMoment() {
        const valorLocal = this.dtAgendamentoLocalString();
        return valorLocal ? moment.tz(valorLocal, 'America/Sao_Paulo') : null;
    }

    // Converte o horário escolhido (interpretado em America/Sao_Paulo) pra UTC antes de mandar pra
    // API — consistente com dtCriacao/dtEnvio, que são sempre gravados/lidos em UTC.
    dtAgendamentoUtc() {
        const momento = this.dtAgendamentoMoment();
        return momento ? momento.utc().toISOString() : null;
    }

    enviar(e) {
        e.preventDefault();
        this.enviarOuSalvar({ salvarRascunho: false });
    }

    salvarRascunho(e) {
        e.preventDefault();
        this.enviarOuSalvar({ salvarRascunho: true });
    }

    agendar(e) {
        e.preventDefault();
        this.enviarOuSalvar({ salvarRascunho: false, agendar: true });
    }

    salvarEdicao(e) {
        e.preventDefault();

        const mensagemValidacao = this.validaFormulario({ exigirAgendamento: this.state.agendarCampanha });
        if (mensagemValidacao) {
            return this.setState({ resultado: { success: false, message: mensagemValidacao } });
        }

        this.setState({ isSending: true, resultado: null });

        const dtAgendamento = this.state.agendarCampanha ? this.dtAgendamentoUtc() : null;

        axios.put(this.Configurations.apiBasePath + `/campanhas-push/${this.state.idCampanhaEditando}`, {
            titulo: this.state.titulo.trim(),
            corpo: this.state.corpo.trim(),
            segmentacao: this.montaSegmentacao(),
            parametros: this.montaParametros(),
            dtAgendamento
        }).then(response => {
            this.setState({ resultado: { ...response.data, dtAgendamento }, formAlteradoDesdeSalvar: false });
        }).catch(err => {
            const resultado = err.response && err.response.data
                ? err.response.data
                : { success: false, message: err.message };
            this.setState({ resultado });
        }).finally(() => this.setState({ isSending: false }));
    }

    // Botão "Enviar campanha agora" que aparece após salvar um rascunho em edição — reusa o mesmo
    // endpoint de disparo de rascunho já usado na lista (POST /campanhas-push/:idCampanha/enviar).
    enviarCampanhaSalva() {
        this.setState({ isSending: true });

        axios.post(this.Configurations.apiBasePath + `/campanhas-push/${this.state.idCampanhaEditando}/enviar`)
            .then(response => {
                this.setState({ resultado: response.data });
            }).catch(err => {
                const resultado = err.response && err.response.data
                    ? err.response.data
                    : { success: false, message: err.message };
                this.setState({ resultado });
            }).finally(() => this.setState({ isSending: false }));
    }

    enviarOuSalvar({ salvarRascunho, agendar = false }) {
        const mensagemValidacao = this.validaFormulario({ exigirAgendamento: agendar });
        if (mensagemValidacao) {
            return this.setState({ resultado: { success: false, message: mensagemValidacao } });
        }

        this.setState({ isSending: true, resultado: null });

        const dtAgendamento = agendar ? this.dtAgendamentoUtc() : null;

        axios.post(this.Configurations.apiBasePath + '/campanhas-push', {
            titulo: this.state.titulo.trim(),
            corpo: this.state.corpo.trim(),
            segmentacao: this.montaSegmentacao(),
            parametros: this.montaParametros(),
            salvarRascunho,
            dtAgendamento
        }).then(response => {
            this.setState({ resultado: response.data });
        }).catch(err => {
            const resultado = err.response && err.response.data
                ? err.response.data
                : { success: false, message: err.message };
            this.setState({ resultado });
        }).finally(() => this.setState({ isSending: false }));
    }

    renderCamposSegmentacao() {
        const { tipoSegmentacao } = this.state;

        if (tipoSegmentacao === 'plataforma') {
            return (
                <div className="form-group col-6">
                    <label htmlFor="plataforma">Plataforma</label>
                    <select id="plataforma" name="plataforma" className="form-control" value={this.state.plataforma} onChange={this.handleChangePlataforma}>
                        <option value="android">Android</option>
                        <option value="ios">iOS</option>
                    </select>
                </div>
            );
        }

        if (tipoSegmentacao === 'topico') {
            return (
                <div className="form-group col-6">
                    <label htmlFor="topico">Nome do tópico</label>
                    <input id="topico" name="topico" type="text" className="form-control"
                        placeholder="ex: promocoes-bs-mais" value={this.state.topico} onChange={this.handleChange} />
                </div>
            );
        }

        if (tipoSegmentacao === 'tokens') {
            return (
                <div className="form-group col-12">
                    <label htmlFor="tokensTexto">Tokens de dispositivo (FCM)</label>
                    <textarea id="tokensTexto" name="tokensTexto" className="form-control" rows="4"
                        placeholder="Um token por linha (ou separados por vírgula)"
                        value={this.state.tokensTexto} onChange={this.handleChange} />
                </div>
            );
        }

        return null;
    }

    renderCampoParametro() {
        const { tipoParametro } = this.state;

        if (tipoParametro === 'url') {
            return (
                <div className="form-group col-12 col-lg-6">
                    <input id="url" name="url" type="text" className="form-control"
                        placeholder="https://..." value={this.state.url} onChange={this.handleChange} />
                </div>
            );
        }

        if (tipoParametro === 'action') {
            return (
                <div className="form-group col-12 col-lg-6">
                    <select id="action" name="action" className="form-control" value={this.state.action} onChange={this.handleChange}>
                        <option value="">Selecione...</option>
                        {ACOES_DISPONIVEIS.map(acao => (
                            <option key={acao.valor} value={acao.valor}>{acao.label}</option>
                        ))}
                    </select>
                </div>
            );
        }

        return null;
    }

    renderResultado() {
        const { resultado } = this.state;
        if (!resultado) return null;

        if (resultado.success && resultado.status === 'agendada') {
            const dtFormatada = resultado.dtAgendamento
                ? moment.utc(resultado.dtAgendamento).tz('America/Sao_Paulo').format('DD/MM/YYYY [às] HH:mm')
                : null;
            return (
                <div className="alert alert-info mt-3">
                    <strong>{this.state.idCampanhaEditando ? 'Agendamento salvo.' : 'Campanha agendada.'}</strong>
                    <div className="small">
                        {dtFormatada
                            ? <>Será enviada automaticamente em <strong>{dtFormatada}</strong> (horário de Brasília).</>
                            : 'Será enviada automaticamente no horário agendado.'}
                    </div>
                    <div className="small"><Link to="/campanhas/lista">Ver histórico de campanhas</Link></div>
                </div>
            );
        }

        if (resultado.success && resultado.status === 'rascunho') {
            return (
                <div className="alert alert-info mt-3">
                    <strong>{this.state.idCampanhaEditando ? 'Alterações salvas.' : 'Campanha salva como rascunho.'}</strong>
                    <div className="small">Ela não foi enviada — acesse o histórico para disparar quando quiser.</div>
                    <div className="small"><Link to="/campanhas/lista">Ver histórico de campanhas</Link></div>
                    {this.state.idCampanhaEditando && (
                        <div className="mt-2">
                            <button type="button" className="btn btn-sm btn-success" onClick={this.enviarCampanhaSalva}
                                disabled={this.state.isSending || this.state.formAlteradoDesdeSalvar}>
                                {this.state.isSending ? 'Enviando...' : 'Enviar campanha agora'}
                            </button>
                            {this.state.formAlteradoDesdeSalvar && (
                                <div className="small text-muted mt-1">Salve as alterações novamente antes de enviar.</div>
                            )}
                        </div>
                    )}
                </div>
            );
        }

        if (resultado.success) {
            return (
                <div className="alert alert-success mt-3">
                    <strong>Campanha enviada com sucesso.</strong>
                    <div className="small">Sucesso: {resultado.totalSucesso} / Erro: {resultado.totalErro}</div>
                    <div className="small"><Link to="/campanhas/lista">Ver histórico de campanhas</Link></div>
                </div>
            );
        }

        return (
            <div className="alert alert-danger mt-3">
                <strong>Erro ao enviar campanha.</strong>
                <div className="small text-break">{resultado.message}</div>
                {resultado.totalSucesso > 0 && (
                    <div className="small">Sucesso parcial: {resultado.totalSucesso} / Erro: {resultado.totalErro}</div>
                )}
            </div>
        );
    }

    // Uma vez que a campanha foi de fato disparada com sucesso (não um rascunho salvo nem um
    // agendamento, que ainda não foram enviados de verdade), esconde "Salvar rascunho"/"Enviar
    // campanha" pra evitar reenviar a mesma campanha clicando de novo — o formulário continua
    // preenchido, então os botões ficando visíveis convidavam a um disparo duplicado.
    campanhaJaEnviada() {
        const { resultado } = this.state;
        return !!(resultado && resultado.success && resultado.status !== 'rascunho' && resultado.status !== 'agendada');
    }

    render() {
        const emEdicao = !!this.state.idCampanhaEditando;

        return (
            <div className="row campaign-create">
                <div className="col-12">
                    <div className="row no-gutters text-left">
                        <h2>{emEdicao ? `Campanhas - Editar campanha #${this.state.idCampanhaEditando}` : 'Campanhas - Nova campanha'}</h2>
                    </div>
                </div>
                <div className="col-12 col-lg-8">
                    {this.state.idCampanhaOrigem && (
                        <div className="alert alert-info mt-3 mb-0">
                            Campos pré-preenchidos a partir da campanha #{this.state.idCampanhaOrigem}. Revise antes de enviar.
                        </div>
                    )}
                    {emEdicao && (
                        <div className="alert alert-warning mt-3 mb-0">
                            Editando a campanha #{this.state.idCampanhaEditando}. As alterações só são gravadas ao clicar em "Salvar alterações".
                        </div>
                    )}
                    <form className="card mt-3" onSubmit={emEdicao ? this.salvarEdicao : this.enviar}>
                        <div className="card-body text-left">
                            <div className="form-group">
                                <label htmlFor="titulo">Título</label>
                                <input id="titulo" name="titulo" type="text" className="form-control"
                                    value={this.state.titulo} onChange={this.handleChange} />
                            </div>
                            <div className="form-group">
                                <label htmlFor="corpo">Corpo</label>
                                <textarea id="corpo" name="corpo" className="form-control" rows="3"
                                    value={this.state.corpo} onChange={this.handleChange} />
                            </div>

                            <label>Público-alvo</label>
                            <div className="form-row mb-2">
                                <div className="col-12">
                                    <div className="form-check form-check-inline">
                                        <input className="form-check-input" type="radio" name="tipoSegmentacao" id="segTodos"
                                            value="todos" checked={this.state.tipoSegmentacao === 'todos'} onChange={this.handleChangeSegmentacao} />
                                        <label className="form-check-label" htmlFor="segTodos">Todos</label>
                                    </div>
                                    <div className="form-check form-check-inline">
                                        <input className="form-check-input" type="radio" name="tipoSegmentacao" id="segPlataforma"
                                            value="plataforma" checked={this.state.tipoSegmentacao === 'plataforma'} onChange={this.handleChangeSegmentacao} />
                                        <label className="form-check-label" htmlFor="segPlataforma">Por plataforma</label>
                                    </div>
                                    {/* Oculto por ora — manter a lógica (renderCamposSegmentacao/montaSegmentacao) pronta pra reativar.
                                    <div className="form-check form-check-inline">
                                        <input className="form-check-input" type="radio" name="tipoSegmentacao" id="segTopico"
                                            value="topico" checked={this.state.tipoSegmentacao === 'topico'} onChange={this.handleChangeSegmentacao} />
                                        <label className="form-check-label" htmlFor="segTopico">Por tópico</label>
                                    </div>
                                    */}
                                    <div className="form-check form-check-inline">
                                        <input className="form-check-input" type="radio" name="tipoSegmentacao" id="segTokens"
                                            value="tokens" checked={this.state.tipoSegmentacao === 'tokens'} onChange={this.handleChangeSegmentacao} />
                                        <label className="form-check-label" htmlFor="segTokens">Tokens específicos</label>
                                    </div>
                                </div>
                            </div>
                            <div className="form-row">
                                {this.renderCamposSegmentacao()}
                            </div>
                            {(this.state.tipoSegmentacao === 'todos' || this.state.tipoSegmentacao === 'plataforma') && (
                                <div className="small text-muted mb-3">
                                    {this.state.isLoadingEstimativa
                                        ? 'Calculando estimativa de alcance...'
                                        : this.state.estimativaPublico !== null
                                            ? <>Esse envio alcançará aproximadamente <strong>{this.state.estimativaPublico}</strong> dispositivo(s). {' '}
                                                <button type="button" className="btn btn-link btn-sm align-baseline" onClick={this.carregaEstimativaPublico}>atualizar</button>
                                              </>
                                            : 'Não foi possível calcular a estimativa de alcance.'}
                                </div>
                            )}

                            <label>Parâmetro customizado (deep link)</label>
                            <div className="form-row mb-2">
                                <div className="col-12">
                                    <div className="form-check form-check-inline">
                                        <input className="form-check-input" type="radio" name="tipoParametro" id="paramNenhum"
                                            value="nenhum" checked={this.state.tipoParametro === 'nenhum'} onChange={this.handleChangeTipoParametro} />
                                        <label className="form-check-label" htmlFor="paramNenhum">Nenhum</label>
                                    </div>
                                    <div className="form-check form-check-inline">
                                        <input className="form-check-input" type="radio" name="tipoParametro" id="paramUrl"
                                            value="url" checked={this.state.tipoParametro === 'url'} onChange={this.handleChangeTipoParametro} />
                                        <label className="form-check-label" htmlFor="paramUrl">URL</label>
                                    </div>
                                    <div className="form-check form-check-inline">
                                        <input className="form-check-input" type="radio" name="tipoParametro" id="paramAction"
                                            value="action" checked={this.state.tipoParametro === 'action'} onChange={this.handleChangeTipoParametro} />
                                        <label className="form-check-label" htmlFor="paramAction">Action</label>
                                    </div>
                                </div>
                            </div>
                            <div className="form-row">
                                {this.renderCampoParametro()}
                            </div>

                            <div className="form-group mt-3">
                                <div className="form-check">
                                    <input className="form-check-input" type="checkbox" id="agendarCampanha"
                                        checked={this.state.agendarCampanha} onChange={this.handleToggleAgendamento} />
                                    <label className="form-check-label" htmlFor="agendarCampanha">Agendar envio para uma data/hora específica</label>
                                </div>
                                {this.state.agendarCampanha && (
                                    <div className="form-row mt-2">
                                        <div className="col-12 col-lg-4">
                                            <label htmlFor="dtAgendamentoData">Data do envio</label>
                                            <input id="dtAgendamentoData" name="dtAgendamentoData" type="date" className="form-control"
                                                value={this.state.dtAgendamentoData} onChange={this.handleChange} />
                                        </div>
                                        <div className="col-6 col-lg-2">
                                            <label htmlFor="dtAgendamentoHora">Hora</label>
                                            <select id="dtAgendamentoHora" name="dtAgendamentoHora" className="form-control"
                                                value={this.state.dtAgendamentoHora} onChange={this.handleChange}>
                                                <option value="">--</option>
                                                {Array.from({ length: 24 }, (_, hora) => (
                                                    <option key={hora} value={hora}>{String(hora).padStart(2, '0')}</option>
                                                ))}
                                            </select>
                                        </div>
                                        <div className="col-6 col-lg-2">
                                            <label htmlFor="dtAgendamentoMinuto">Minuto</label>
                                            <select id="dtAgendamentoMinuto" name="dtAgendamentoMinuto" className="form-control"
                                                value={this.state.dtAgendamentoMinuto} onChange={this.handleChange}>
                                                <option value="00">00</option>
                                                <option value="30">30</option>
                                            </select>
                                        </div>
                                        <div className="col-12">
                                            <div className="small text-muted mt-1">Horário de Brasília.</div>
                                        </div>
                                    </div>
                                )}
                            </div>

                            <div className="text-right mt-3">
                                {emEdicao ? (
                                    <button type="submit" className="btn btn-primary" disabled={this.state.isSending}>
                                        {this.state.isSending ? 'Salvando...' : 'Salvar alterações'}
                                    </button>
                                ) : !this.campanhaJaEnviada() && (
                                    <>
                                        <button type="button" className="btn btn-outline-secondary mr-2" onClick={this.salvarRascunho} disabled={this.state.isSending}>
                                            {this.state.isSending ? 'Salvando...' : 'Salvar rascunho'}
                                        </button>
                                        {this.state.agendarCampanha ? (
                                            <button type="button" className="btn btn-primary" onClick={this.agendar} disabled={this.state.isSending}>
                                                {this.state.isSending ? 'Agendando...' : 'Agendar envio'}
                                            </button>
                                        ) : (
                                            <button type="submit" className="btn btn-primary" disabled={this.state.isSending}>
                                                {this.state.isSending ? 'Enviando...' : 'Enviar campanha'}
                                            </button>
                                        )}
                                    </>
                                )}
                            </div>

                            {this.renderResultado()}
                        </div>
                    </form>
                </div>
            </div>
        )
    }
}

export default CampaignCreate;
